<template>
  <div
    :class="[
      $style.providersGamesCard,
      { [$style.providerGamesCardResticted]: provider.restricted },
    ]"
    @click="goToProvider(provider.providerId)"
  >
    <div>
      <img
        :src="provider.providerIcon?.url"
        :class="[
          $style.providersGamesCardImg,
          { [$style.providersGamesCardImgREstricted]: provider.restricted },
        ]"
      />
      <NuxtLink
        :class="[$style.providersGamesCardLink, $style.restricted]"
        :to="localePath(`/${provider.providerId}`)"
      >
        <template v-if="highlightTitle">
          <span>{{ provider.startTitle }}</span>
          <span :class="$style.centerTitle">{{ provider.boldTitle }}</span>
          <span>{{ provider.endTitle }}</span>
        </template>
        <template v-else>
          {{ provider.providerTitle }}
        </template>
      </NuxtLink>
      <div v-if="!provider.restricted" :class="$style.providersGamesCardInfo">
        <span :class="$style.providersGamesCardInfoNumbers">
          {{ provider.gamesCount }}
          {{
            provider.type === EProviderType.Games
              ? data.gamesTypeTitle
              : replaceSlotsToPokiesIfNeeded(data.slotsTypeTitle)
          }}
        </span>
      </div>
    </div>

    <div v-if="provider.restricted" :class="$style.restrictedText">
      {{ storeComponents.sortProvider.providerNotAvailableTitle }}
    </div>

    <div v-if="!provider.restricted" :class="$style.gamesCatalogueProviderContainer" @click.stop>
      <GameThumbnail
        v-for="(item, index) in provider.imageUrls"
        :key="index"
        :class="$style.gamesCatalogueItem"
        :game="item"
        variant="freespins"
        :favorite-games="favoriteGames"
      />
    </div>

    <BitButton
      v-if="!provider.restricted"
      type="secondary"
      @click="goToProvider(provider.providerId)"
    >
      <template #prependIcon>
        <img src="/images/common/chevron_right.svg?url_encode" alt="" />
      </template>
      {{ storeComponents.sortProvider.nameButtonShow }}
    </BitButton>
  </div>
</template>

<script lang="ts" setup>
import { BitButton } from '@bit/ui-kit';
import { GameThumbnail } from '~/components/lib/mainPage';
import { useTextReplacements } from '~/composables/useTextReplacements';
import { useStoreRoot } from '~/stores/abstract/root';
import { useStoreSsGamesFavourite } from '~/stores/softswiss/gamesFavourite';
import { useStoreComponents } from '~/stores/strapi/components';
import { EProviderType } from '~/types/providers';

defineProps({
  provider: {
    type: Object,
    required: true,
  },
  data: {
    type: Object,
    required: true,
  },
  highlightTitle: {
    type: Boolean,
    default: false,
  },
});

const router = useRouter();
const storeComponents = useStoreComponents();
const textReplacements = useTextReplacements();
const storeSsGamesFavourite = useStoreSsGamesFavourite();

const favoriteGames = computed(() => storeSsGamesFavourite.gameIds);

const localePath = (value: string) => useStoreRoot().localePath(value);
const replaceSlotsToPokiesIfNeeded = (value: string) =>
  textReplacements.replaceSlotsToPokiesIfNeeded(value);

const goToProvider = (providerId: string) => {
  router.push({
    path: useStoreRoot().localePath(`/${providerId}`),
  });
};
</script>

<style lang="scss" module src="./providerCard.scss"></style>
